export default __webpack_public_path__ + "static/media/insta_logo.787b1447.svg";